export interface MeetingsState {
  meetingsAndOwnersList?: [];
}

export const initialMeetingsState: MeetingsState = {
  meetingsAndOwnersList: []
};
